(function () {
  'use strict';

  if (window.__titaniumFeaturedCollectionAssetLoaded) return;
  window.__titaniumFeaturedCollectionAssetLoaded = true;

  var CAROUSEL_SELECTOR = '[data-titanium-featured-carousel]';
  var SECTION_SELECTOR = '[id^="CollectionSection-"]';
  var DESKTOP_QUERY = '(min-width: 769px)';
  var SWIPER_CSS_SELECTOR = 'link[data-tfc-swiper-css="true"]';
  var SWIPER_JS_SELECTOR = 'script[data-tfc-swiper-js="true"]';

  function toBoolean(value, fallback) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
  }

  function toNumber(value, fallback) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function ensureSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (window.__tfcSwiperPromise) return window.__tfcSwiperPromise;

    window.__tfcSwiperPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector(SWIPER_CSS_SELECTOR)) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = window.TITANIUM_FEATURED_COLLECTION_SWIPER_CSS || '';
        link.setAttribute('data-tfc-swiper-css', 'true');
        if (link.href) document.head.appendChild(link);
      }

      var existing = document.querySelector(SWIPER_JS_SELECTOR);
      if (existing) {
        var attempts = 0;
        var wait = window.setInterval(function () {
          attempts += 1;
          if (window.Swiper) {
            window.clearInterval(wait);
            resolve(window.Swiper);
          } else if (attempts >= 100) {
            window.clearInterval(wait);
            reject(new Error('Swiper did not become available.'));
          }
        }, 50);
        return;
      }

      var script = document.createElement('script');
      script.src = window.TITANIUM_FEATURED_COLLECTION_SWIPER_JS || '';
      script.defer = true;
      script.setAttribute('data-tfc-swiper-js', 'true');
      script.onload = function () {
        if (window.Swiper) resolve(window.Swiper);
        else reject(new Error('Swiper loaded without a global constructor.'));
      };
      script.onerror = function () {
        reject(new Error('Unable to load the local Swiper asset.'));
      };
      if (script.src) document.head.appendChild(script);
      else reject(new Error('Swiper asset URL is missing.'));
    });

    return window.__tfcSwiperPromise;
  }

  function destroyCarousel(carousel) {
    if (carousel.__tfcSwiper && carousel.__tfcSwiper.destroy) {
      carousel.__tfcSwiper.destroy(true, true);
    }
    carousel.__tfcSwiper = null;
    carousel.classList.remove('tfc__carousel--initialized');
  }

  function carouselIsEnabled(carousel, desktop) {
    return desktop
      ? toBoolean(carousel.getAttribute('data-desktop-slider'), true)
      : toBoolean(carousel.getAttribute('data-mobile-slider'), true);
  }

  function mountCarousel(carousel) {
    var desktop = window.matchMedia(DESKTOP_QUERY).matches;
    if (!carouselIsEnabled(carousel, desktop)) {
      destroyCarousel(carousel);
      return;
    }

    var viewport = carousel.querySelector('.tfc__viewport');
    var track = carousel.querySelector('.tfc__track');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.children).filter(function (child) {
      return child.classList && child.classList.contains('tfc__slide');
    });
    if (!slides.length) return;

    ensureSwiper().then(function () {
      if (!document.documentElement.contains(carousel)) return;
      destroyCarousel(carousel);

      var slidesPerView = desktop
        ? toNumber(carousel.getAttribute('data-slides-desktop'), 4)
        : toNumber(carousel.getAttribute('data-slides-mobile'), 1.5);
      var gap = desktop
        ? toNumber(carousel.getAttribute('data-gap-desktop'), 24)
        : toNumber(carousel.getAttribute('data-gap-mobile'), 12);
      var groupMode = carousel.getAttribute('data-group-mode') || 'single';
      var slidesPerGroup = groupMode === 'page' ? Math.max(1, Math.floor(slidesPerView)) : 1;
      var autoplayEnabled = toBoolean(carousel.getAttribute('data-autoplay'), false)
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayDelay = Math.max(2, toNumber(carousel.getAttribute('data-autoplay-delay'), 5)) * 1000;
      var previous = carousel.querySelector('.tfc__arrow--prev');
      var next = carousel.querySelector('.tfc__arrow--next');

      carousel.__tfcSwiper = new window.Swiper(viewport, {
        wrapperClass: 'tfc__track',
        slideClass: 'tfc__slide',
        slideActiveClass: 'tfc__slide--active',
        slideVisibleClass: 'tfc__slide--visible',
        slidesPerView: slidesPerView,
        slidesPerGroup: slidesPerGroup,
        spaceBetween: gap,
        speed: Math.max(100, toNumber(carousel.getAttribute('data-speed'), 650)),
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: toBoolean(carousel.getAttribute('data-grab-cursor'), true),
        threshold: 4,
        longSwipesRatio: 0.2,
        resistanceRatio: 0.7,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        rewind: toBoolean(carousel.getAttribute('data-rewind'), false),
        navigation: previous && next ? { prevEl: previous, nextEl: next } : false,
        autoplay: autoplayEnabled ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        on: {
          init: function () {
            carousel.classList.add('tfc__carousel--initialized');
          }
        }
      });
    }).catch(function () {
      destroyCarousel(carousel);
    });
  }

  function initializeCarousel(carousel) {
    if (carousel.__tfcBound) {
      mountCarousel(carousel);
      return;
    }

    carousel.__tfcBound = true;
    var media = window.matchMedia(DESKTOP_QUERY);
    var onBreakpointChange = function () { mountCarousel(carousel); };
    if (media.addEventListener) media.addEventListener('change', onBreakpointChange);
    else media.addListener(onBreakpointChange);
    carousel.__tfcMedia = media;
    carousel.__tfcMediaListener = onBreakpointChange;
    mountCarousel(carousel);
  }

  function refreshVisibleCarousel(section) {
    window.setTimeout(function () {
      Array.prototype.slice.call(section.querySelectorAll(CAROUSEL_SELECTOR)).forEach(function (carousel) {
        if (carousel.offsetParent === null) return;
        if (carousel.__tfcSwiper && carousel.__tfcSwiper.update) carousel.__tfcSwiper.update();
        else mountCarousel(carousel);
      });
    }, 30);
  }

  function initializeTabs(section) {
    if (section.__tfcTabsBound) return;
    section.__tfcTabsBound = true;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('.collection-tabs button'));
    var contents = Array.prototype.slice.call(section.querySelectorAll('.collection-content'));
    var headerViewAll = section.querySelector('.collection-view-all');

    function selectTab(tab) {
      var targetIndex = tab.getAttribute('data-index');
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });
      contents.forEach(function (content) {
        content.classList.toggle('active', content.getAttribute('data-index') === targetIndex);
      });
      if (headerViewAll && tab.getAttribute('data-url')) {
        headerViewAll.setAttribute('href', tab.getAttribute('data-url'));
      }
      refreshVisibleCarousel(section);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        selectTab(tabs[nextIndex]);
      });
    });

    if (tabs.length) selectTab(tabs.find(function (tab) { return tab.classList.contains('active'); }) || tabs[0]);
  }

  function initialize(root) {
    var scope = root || document;
    var sections = [];
    if (scope.matches && scope.matches(SECTION_SELECTOR)) sections.push(scope);
    sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll(SECTION_SELECTOR) : []));

    sections.forEach(function (section) {
      initializeTabs(section);
      Array.prototype.slice.call(section.querySelectorAll(CAROUSEL_SELECTOR)).forEach(initializeCarousel);
      refreshVisibleCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('recommendations:loaded', function (event) {
    var root = event.detail && event.detail.section ? event.detail.section : document;
    initialize(root);
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:reorder', function () { initialize(document); });
}());
